/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminMarketplaceType,
    AdminMarketplaceTypeFromJSON,
    AdminMarketplaceTypeFromJSONTyped,
    AdminMarketplaceTypeToJSON,
} from './AdminMarketplaceType';

/**
 * 
 * @export
 * @interface AdminMarketplaceCount
 */
export interface AdminMarketplaceCount {
    /**
     * 
     * @type {number}
     * @memberof AdminMarketplaceCount
     */
    count: number;
    /**
     * 
     * @type {AdminMarketplaceType}
     * @memberof AdminMarketplaceCount
     */
    marketplace: AdminMarketplaceType;
}



export function AdminMarketplaceCountFromJSON(json: any): AdminMarketplaceCount {
    return AdminMarketplaceCountFromJSONTyped(json, false);
}

export function AdminMarketplaceCountFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminMarketplaceCount {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'marketplace': AdminMarketplaceTypeFromJSON(json['marketplace']),
    };
}

export function AdminMarketplaceCountToJSON(value?: AdminMarketplaceCount | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'marketplace': AdminMarketplaceTypeToJSON(value.marketplace),
    };
}

